import React from 'react';
import { Typography, Divider } from 'antd';

const { Title, Paragraph, Text } = Typography;

const Privacy: React.FC = () => (
  <div style={{ background: '#fff', maxWidth: 800, margin: '0 auto', padding: '40px 24px' }}>
    <Title level={2}>Privacy Policy</Title>
    <Paragraph>
      <Text strong>COMPANY:</Text> Shaho Solutions Limited<br />
      <Text strong>TRADING AS:</Text> ShahoSuite<br />
      <Text strong>CONTACT EMAIL:</Text> admin@shahosuite.com<br />
    </Paragraph>
    <Divider />
    <Paragraph>
      <Text strong>1. Who We Are</Text><br />
      Shaho Solutions Limited (Company Number: 16017117), trading as ShahoSuite, is the data controller.<br />
      Registered Office: Oathall House, C/O Umpleby Accountancy, 68-70 Oathall Road, Haywards Heath, West Sussex, RH16 3EN, United Kingdom.<br />
      Contact: admin@shahosuite.com
    </Paragraph>
    <Paragraph>
      <Text strong>2. What Data We Collect</Text><br />
      Business name, contact name, email, phone<br />
      Payment data processed by Stripe<br />
      Usage data and logs<br />
      Staff and customer data you enter into the platform
    </Paragraph>
    <Paragraph>
      <Text strong>3. How We Use Your Data</Text><br />
      To provide the ShahoSuite service<br />
      To send account and billing emails<br />
      To comply with legal obligations
    </Paragraph>
    <Paragraph>
      <Text strong>4. Legal Basis for Processing (UK GDPR)</Text><br />
      Contract performance<br />
      Legal obligation<br />
      Legitimate interests<br />
      Where processing is based on consent, you may withdraw consent at any time by contacting admin@shahosuite.com
    </Paragraph>
    <Paragraph>
      <Text strong>5. Data Retention</Text><br />
      Active accounts: retained while subscribed<br />
      After cancellation: deleted after 30 days<br />
      Financial records: retained for 6 years in anonymised form for HMRC compliance
    </Paragraph>
    <Paragraph>
      <Text strong>6. Your Rights (UK GDPR)</Text><br />
      Right to access your data<br />
      Right to correct inaccurate data<br />
      Right to delete your data<br />
      Right to data portability<br />
      Right to object to processing<br />
      Exercise rights: admin@shahosuite.com
    </Paragraph>
    <Paragraph>
      <Text strong>7. Third-Party Processors</Text><br />
      Stripe (payments) — stripe.com/privacy<br />
      Microsoft Azure (hosting)<br />
      Azure Communication Services (email delivery)<br />
      Shaho Solutions Limited is not responsible for third-party outages or data incidents.
    </Paragraph>
    <Paragraph>
      <Text strong>8. Data Security</Text><br />
      Encrypted in transit and at rest<br />
      Access controls and authentication<br />
      Regular security reviews
    </Paragraph>
    <Paragraph>
      <Text strong>9. Cookies</Text><br />
      Essential cookies only<br />
      No advertising or tracking cookies
    </Paragraph>
    <Paragraph>
      <Text strong>10. Changes to This Policy</Text><br />
      30 days notice for material changes<br />
      Continued use means acceptance
    </Paragraph>
    <Paragraph>
      <Text strong>11. Complaints</Text><br />
      Contact us first: admin@shahosuite.com<br />
      ICO: ico.org.uk — 0303 123 1113
    </Paragraph>
    <Paragraph>
      <Text strong>12. Copyright</Text><br />
      © 2026 Shaho Solutions Limited. All rights reserved.
    </Paragraph>
    <Paragraph>
      <Text strong>13. Contact</Text><br />
      admin@shahosuite.com<br />
      Shaho Solutions Limited<br />
      Company Number: 16017117<br />
      Registered Office: Oathall House, C/O Umpleby Accountancy, 68-70 Oathall Road, Haywards Heath, West Sussex, RH16 3EN, United Kingdom
    </Paragraph>
    <Divider />
    <div style={{ textAlign: 'center', marginTop: 40 }}>
      <Text type="secondary">© 2026 Shaho Solutions Limited. All rights reserved.</Text>
    </div>
  </div>
);

export default Privacy;
